module.exports = __webpack_public_path__ + "static/media/workingmemory-words-4.bd1b0caf.mp3";